<template>
  <div class="coat" onselectstart="return false;">
    <!-- 雅格科技 -->
    <div class="section">
      <img src="../assets/about/yage.png" alt="" />
    </div>
    <!-- 发展历程 -->
    <div class="section">
      <img src="../assets/about/develope.jpg" alt="" />
    </div>
    <!-- 荣誉证书 -->
    <div class="certificate">
      <div class="title">资质荣誉</div>
      <div class="line"></div>
      <div class="img-across vertical">
        <img style="width:47.5%;" src="../assets/about/gxjs.png" alt="" />
        <img style="width:47.5%;" src="../assets/about/cyjh.png" alt="" />
      </div>
      <div class="img-vertical">
        <img src="../assets/about/kjx.png" alt="" />
        <img src="../assets/about/jskf.png" alt="" />
        <img src="../assets/about/2.png" alt="" />
        <img src="../assets/about/3.png" alt="" />
        <img src="../assets/about/1.png" alt="" />
        <img src="../assets/about/dsjksh.png" alt="" />
        <img src="../assets/about/RPA.png" alt="" />
        <img src="../assets/about/ygy.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      img_height: "",
    };
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      _this.img_load();
    };
  },
  computed: {},
  methods: {
    // 重新加载轮播图高度的控制
    img_load() {
      this.img_height = this.$refs.img.height;
    },
  },
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;
  background: #F5F5F5;
  padding-bottom: 60px;
  // 图片不模糊
  image-rendering:-moz-crisp-edges;
  image-rendering: -o-crisp-edges; 
  image-rendering: -webkit-optimize-contrast; 
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; 
  // 雅格科技介绍
  .section{
    margin: 0;
    img{
      width: 100%;
      height: auto;
      margin-bottom: -5px;
    }
  }
  // 荣誉证书
  .certificate{
    margin: 0;
    .title{
      text-align: center;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 42px;
      margin: 30px auto 5px;
      cursor: pointer;
    }
    .line{
      margin: 10px auto;
      width: 106px;
      height: 4px;
      background: linear-gradient(-90deg, rgba(0, 204, 255, 0.95), rgba(0, 61, 230, 0.95));
      border-radius: 3px;
    }
    // 证书横放的
    .img-across{
      width: 80%;
      display: flex;
      justify-content: space-between;
      margin:  40px auto 0;
      // img{
      //   width: 45%;
      // }
    }
    // 证书竖放的
    .img-vertical{
      width: 80%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 20px auto;
      img{
        width: 30%;
        margin: 20px 0;
      }
    }
  }
}
</style>
